import * as types from './actionTypes';
import initialState from './initialState';

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case types.GET_ENTITIES_CONNECTED_DICTIONARIES_REQUEST:
    case types.GET_ENTITIES_DICTIONARIES_REQUEST:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: true,
        },
      };
    case types.GET_ENTITIES_DICTIONARIES_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: false,
          data: {
            ...state.list.data,
            items: [...action.payload.items, ...state.list.data.items],
            count: action.payload.count + state.list.data.count,
          },
        },
      };
    case types.GET_ENTITIES_CONNECTED_DICTIONARIES_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: false,
          data: {
            ...state.list.data,
            items: action.payload.items,
            count: action.payload.count,
          },
        },
      };
    case types.GET_ENTITIES_CONNECTED_DICTIONARIES_ERROR:
    case types.GET_ENTITIES_DICTIONARIES_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: false,
          error: action.payload.error,
        },
      };
    default:
      return state;
  }
};
